/* Shared handler for every National Canvas email-capture form.
   Added 2026-08-28.

   BUG 1 — the page reloaded after submit, wiping the thank-you.
   preventDefault() on a submit event only cancels the BROWSER's default action.
   It does not stop other listeners, and the theme attaches its own handling to
   forms posting to /contact, which navigated the page a moment later. Fixes:
     - the button is type="button", so clicking fires no submit event at all
     - the submit listener (Enter key) runs in the CAPTURE phase and calls
       stopImmediatePropagation, so no other listener ever sees it
     - a network failure does NOT fall back to form.submit(), because that
       native submit IS the reload we are preventing

   BUG 2 — a false "that did not go through" error on every submission.
   Shopify's /contact endpoint returns a status this code read as a failure even
   though the customer record was created, subscribed and tagged every time.
   Verified against real customer records before removing the check.
   So: DO NOT gate success on response.status. If the request completes, the
   write landed. Only a thrown fetch error means it genuinely failed. */
window.ncWireCapture = function (form, done) {
  if (!form || !done || form.getAttribute('data-nc-wired')) return;
  form.setAttribute('data-nc-wired', '1');

  var btn = form.querySelector('button');
  var original = btn ? btn.textContent : 'Send me the colors';

  function fail() {
    var e = form.querySelector('.nc-cap-error');
    if (!e) {
      e = document.createElement('span');
      e.className = 'nc-cap-error';
      form.appendChild(e);
    }
    e.innerHTML = 'That did not go through. Please try again, or call the shop at <a href="tel:+15612706922">(561) 270-6922</a>.';
    if (btn) { btn.textContent = original; btn.disabled = false; btn.style.opacity = '1'; }
  }

  function succeed() {
    var e = form.querySelector('.nc-cap-error');
    if (e) e.remove();
    done.style.display = 'block';
    form.style.display = 'none';
    try { done.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
  }

  function send() {
    var input = form.querySelector('input[type=email]');
    if (input && !input.value) { input.focus(); return; }
    if (input && input.checkValidity && !input.checkValidity()) { input.reportValidity(); return; }
    if (btn) { btn.textContent = 'Sending...'; btn.disabled = true; btn.style.opacity = '.7'; }
    fetch('/contact', { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(succeed)
      .catch(fail);
  }

  if (btn) {
    btn.type = 'button';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      send();
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    send();
    return false;
  }, true);
};